import { getTableNode } from './nodes/table';
import { getTableCellNode } from './nodes/tableCell';
import { getTableHeaderNode } from './nodes/tableHeader';
import { getTableRowNode } from './nodes/tableRow';
function getCellAttrs(dom, extraAttrs) {
  let widthAttr = dom.getAttribute('data-colwidth');
  let widths = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map(s => Number(s)) : null;
  let colspan = Number(dom.getAttribute('colspan') || 1);
  let result = {
    colspan,
    rowspan: Number(dom.getAttribute('rowspan') || 1),
    colwidth: widths && widths.length == colspan ? widths : null
  };
  for (let prop in extraAttrs) {
    let getter = extraAttrs[prop].getFromDOM;
    let value = getter && getter(dom);
    if (value != null) result[prop] = value;
  }
  return result;
}
function setCellAttrs(node, extraAttrs, dom) {
  let attrs = {};
  if (node.attrs.colspan != 1) attrs.colspan = node.attrs.colspan;
  if (node.attrs.rowspan != 1) attrs.rowspan = node.attrs.rowspan;
  if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
  for (let prop in extraAttrs) {
    let setter = extraAttrs[prop].setDOMAttr;
    if (setter) setter(node.attrs[prop], attrs, dom);
  }
  return attrs;
}
const tableNodes = options => {
  return {
    table: getTableNode(options),
    table_row: getTableRowNode(),
    table_cell: getTableCellNode(options),
    table_header: getTableHeaderNode(options)
  };
};
const tableNodeTypes = schema => {
  let result = schema.cached.tableNodeTypes;
  if (!result) {
    result = schema.cached.tableNodeTypes = {};
    for (let name in schema.nodes) {
      let type = schema.nodes[name],
        role = type.spec.tableRole;
      if (role) result[role] = type;
    }
  }
  return result;
};
export { getCellAttrs, setCellAttrs, tableNodes, tableNodeTypes };